import {Button, Divider} from '@mui/material';
import LabelText from '../label-text/label-text';
import amasaImage from '../../images/amasa.png';

import styles from './liquidity-mining.module.css';
import {useWeb3React} from '@web3-react/core';
import React, {useContext, useEffect} from 'react';
import {LoadingContext, LoadingItem} from '../../context/loader';
import {getDefaultProvider, Web3Provider} from '@ethersproject/providers';
import {TokenService} from '../../services/TokenService';
import {LiquidityMiningService, StakingType} from '../../services/LiquidyMiningService';
import LiquidityWithdrawDialog from "../liquidity-withdraw-dialog/liquidity-withdraw-dialog";
import {MessageContext} from "../../context/messaging";
import {formatEther} from "@ethersproject/units";

function LiquidityMining(props: any) {
    const {library, account} = useWeb3React();
    const {refresh, loadingData, setLoadingData, setRefresh} = useContext(
        LoadingContext,
    );
    const [withdrawDialogOpen, setWithdrawDialogOpen] = React.useState(false);
    const [dataModel, setDataModel] = React.useState({
        name: 'LiquidityMining_' + props.stakingType,
        poolStatus: '',
        stakedBalancePretty: '0',
        stakedBalance: '0',
        progress: '0',
        withdrawDate: '',
        stakeApprove: false,
        balance: null,
        pendingReward: '0',
        pendingRewardPretty: '0',
        apy: 0,
        totalValueLocked: -1,
        stakingType: props.stakingType
    });
    const {
        setMessageOpen,
        setSeverity,
        setMessageText
    } = useContext(MessageContext);

    useEffect(() => {
        fetchData(account, library);
    }, [account, refresh]);
    const [dialogData, setDialogData] = React.useState();

    const handleWithdrawDialogOpen = (data: any) => {
        setDialogData(data);
        setWithdrawDialogOpen(true);
    };

    const handleWithdrawDialogClose = () => {
        setWithdrawDialogOpen(false);
    };

    async function harvest() {
        loadingData.set('LiquidityMining-ClaimReward', {message: 'Start claiming...'});
        setLoadingData(loadingData);
        let hasError = false;

        let tx = await LiquidityMiningService(library, props.stakingType).claimReward().catch((error) => {
                console.log(error);
                setMessageOpen(true);
                setSeverity("error");
                setMessageText('Harvesting failed');
                hasError = true;
            }
        );
        if (tx !== undefined) {
            await tx.wait().catch((error: any) => {
                console.log(error);
                setMessageOpen(true);
                setSeverity("error");
                setMessageText('Harvesting failed');
                hasError = true;
            });
        }
        loadingData.delete('LiquidityMining-ClaimReward');
        setLoadingData(loadingData);
        if (!hasError) {
            setMessageOpen(true);
            setSeverity("success");
            setMessageText('Liquidity harvesting done.');
        }
        setRefresh('LiquidityMining_' + props.stakingType + "_" + new Date().getTime());
    }

    function isStakeEnable() {
        // return Number(dataModel.balance) > 0;
        return false;
    }

    function isUnStakeEnable() {
        return Number(dataModel.stakedBalance.toString()) > 0;
    }

    function isHarvestEnable() {
        return Number(dataModel.pendingReward) > 0;
    }

    return (
        <div className={`${styles.container}`}>
            <LiquidityWithdrawDialog
                open={withdrawDialogOpen}
                data={dialogData}
                handleWithdrawDialogOpen={handleWithdrawDialogOpen}
                handleWithdrawDialogClose={handleWithdrawDialogClose}
            />
            <div className={`${styles.header}`}>
                <div className={`${styles.title}`}>{props.title}</div>
                <div className={`${styles.stakingWithImage}`}>
                    <div className={`${styles.amasaIcon}`}>
                        <img className={`${styles.amasaIcon}`} alt="" src={amasaImage}/>
                    </div>
                    {/*<div className={`${styles.stakingText}`}>Staking</div>*/}
                </div>
            </div>
            <div className={`${styles.apyContainer}`}>
                <div className={`${styles.apyLabel}`}>Current APY</div>
                <div className={`${styles.apyText}`}>{dataModel.apy}%</div>
            </div>
            <div className={`${styles.labelTextContainer}`}>
                <LabelText label="Total Value Locked"
                           text={'$' + (dataModel.totalValueLocked === -1 ? '' : dataModel.totalValueLocked)}/>
            </div>
            <div className={`${styles.labelTextContainer}`}>
                <LabelText label="Pool Size"
                           text={props.stakingType === StakingType.FIRST ? (process.env.REACT_APP_LIQUIDITY_STAKING_POOL_SIZE || '') : (process.env.REACT_APP_SECOND_LIQUIDITY_STAKING_POOL_SIZE || '')}/>
            </div>
            <div className={`${styles.labelTextContainer}`}>
                <LabelText label="Pool Status" text="OPEN"/>
            </div>
            <div className={`${styles.labelTextContainer}`}>
                <LabelText
                    label="Your Stake"
                    text={dataModel.stakedBalance}
                />
            </div>
            <div className={`${styles.labelTextContainer}`}>
                <LabelText
                    label="Your Reward"
                    text={dataModel.pendingReward === '0' ? '0' : formatEther(dataModel.pendingReward)}
                />
            </div>
            <div className={`${styles.divider}`}>
                <Divider/>
            </div>
            <div className={`${styles.actionButtons}`}>
                <div className={isStakeEnable() ? `${styles.stakeButtonEnable}`
                    : `${styles.stakeButtonDisable}`}>
                    <Button
                        disabled={!isStakeEnable()}
                        className={`${styles.stakeButtonText}`}
                        onClick={() => {
                            props.handleStakingDialogOpen(dataModel);
                        }}
                    >
                        Stake Now
                    </Button>
                </div>
                <div className={isUnStakeEnable() ? `${styles.withdrawButtonEnable}`
                    : `${styles.withdrawButtonDisable}`}>
                    <Button
                        disabled={!isUnStakeEnable()}
                        className={`${styles.stakeButtonText}`}
                        onClick={() => {
                            handleWithdrawDialogOpen(dataModel);
                        }}
                    >
                        Unstake
                    </Button>
                </div>
                <div className={isHarvestEnable() ? `${styles.claimButtonEnable}`
                    : `${styles.claimButtonDisable}`}>
                    <Button
                        disabled={!isHarvestEnable()}
                        className={`${styles.stakeButtonText}`}
                        onClick={harvest}
                    >
                        Harvest
                    </Button>
                </div>
            </div>
        </div>
    );

    async function fetchData(
        account: string | null | undefined,
        provider: Web3Provider,
    ) {
        if (refresh !== '' && !refresh.includes('LiquidityMining_' + props.stakingType)) {
            return;
        }
        loadingData.set('LiquidityMiningLoadData', {message: 'Loading staking info'});
        setLoadingData(new Map<string, LoadingItem>(loadingData));

        let model = {
            name: 'LiquidityMining_' + props.stakingType,
            poolStatus: '',
            stakedBalancePretty: '0',
            stakedBalance: '0',
            progress: '0',
            withdrawDate: '',
            stakeApprove: false,
            balance: null,
            pendingReward: '0',
            pendingRewardPretty: '0',
            apy: 0,
            totalValueLocked: -1,
            stakingType: props.stakingType
        };
        const correctNetwork = process.env.REACT_APP_NETWORK_ID || '1';
        const stakingInfo = await LiquidityMiningService((correctNetwork === '4' ? getDefaultProvider('rinkeby') : getDefaultProvider()), props.stakingType).getStakingInfo();
        model.apy = stakingInfo.apy;
        model.totalValueLocked = stakingInfo.totalValueLocked;
        if (account === undefined) {
            loadingData.delete('LiquidityMiningLoadData');
            setLoadingData(new Map<string, LoadingItem>(loadingData));
            console.log('no account');
            setDataModel(model);
            return;
        }

        TokenService(provider)
            .geBalance(account, process.env.REACT_APP_LP_TOKEN_ADDRESS || '')
            .then(balance => {
                model.balance = balance;
                LiquidityMiningService(provider, props.stakingType)
                    .getStakedBalanceLiq(account, false)
                    .then(stakedBalance => {
                        model.stakedBalancePretty = stakedBalance.stakedBalancePretty;
                        model.stakedBalance = stakedBalance.stakedBalance.toString();
                        LiquidityMiningService(provider, props.stakingType)
                            .checkApproval(account, process.env.REACT_APP_LP_TOKEN_ADDRESS || '')
                            .then(approve => {
                                model.stakeApprove = approve;
                                LiquidityMiningService(provider, props.stakingType).getPendingReward(account, false).then((rewardData) => {
                                    model.pendingReward = rewardData.pendingReward.toString();
                                    model.pendingRewardPretty = rewardData.pendingRewardPretty.toString();
                                    setDataModel(model);
                                    if (props.getCurrentStaking() === model.name) {
                                        props.handleSetDialogData({...model, stakingType: props.stakingType});
                                    }
                                    loadingData.delete('LiquidityMiningLoadData');
                                    setLoadingData(new Map<string, LoadingItem>(loadingData));
                                });
                            });
                    });
            })
            .catch(err => {
                console.log(err);
                loadingData.delete('LiquidityMiningLoadData');
                setLoadingData(new Map<string, LoadingItem>(loadingData));
            });
    }
}

export default LiquidityMining;
